export function formatPhoneRu(raw: string): string {
  const d = raw.replace(/\D/g, "").replace(/^8/, "7").slice(0, 11);
  if (!d) return "";
  let out = "+7";
  if (d.length > 1) out += " (" + d.slice(1, 4);
  if (d.length >= 5) out += ") " + d.slice(4, 7);
  if (d.length >= 8) out += "-" + d.slice(7, 9);
  if (d.length >= 10) out += "-" + d.slice(9, 11);
  return out;
}

export function digitsOnly(raw: string): string {
  return raw.replace(/\D/g, "");
}

export function validateTrc20(address: string): boolean {
  return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(address.trim());
}

export function formatRub(n: number): string {
  return new Intl.NumberFormat("ru-RU", { style: "currency", currency: "RUB", maximumFractionDigits: 0 }).format(n);
}

export function formatUsdt(n: number): string {
  return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " USD";
}

export function maskMiddle(s: string, head = 6, tail = 4): string {
  if (s.length <= head + tail) return s;
  return s.slice(0, head) + "…" + s.slice(-tail);
}

export function maskPhone(phone: string): string {
  const d = phone.replace(/\D/g, "");
  if (d.length < 11) return phone;
  return `+${d[0]} ${d.slice(1, 4)} ••• ${d.slice(-2)}`;
}

export function initialsFromName(full: string): string {
  const parts = full.trim().split(/\s+/);
  if (parts.length === 0) return "?";
  const first = parts[0]?.[0] ?? "";
  const second = parts[1]?.[0] ?? "";
  return (first + second).toUpperCase();
}

export function formatRelative(ts: number): string {
  const diff = Date.now() - ts;
  const m = 60_000, h = 60 * m, d = 24 * h;
  if (diff < m) return "только что";
  if (diff < h) return `${Math.floor(diff / m)} мин назад`;
  if (diff < d) return `${Math.floor(diff / h)} ч назад`;
  if (diff < 7 * d) return `${Math.floor(diff / d)} дн назад`;
  return new Date(ts).toLocaleDateString("ru-RU", { day: "2-digit", month: "short" });
}
